export const movies = [
  {
    id: 1,
    title: "星海航行",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20art%2C%20lone%20astronaut%20gazing%20at%20a%20glowing%20amber%20nebula%20and%20distant%20starship%2C%20deep%20teal%20and%20warm%20gold%20lighting%2C%20epic%20dramatic%20atmosphere%2C%20high%20detail%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m1&orientation=portrait",
    genres: ["科幻", "冒险", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 9.1,
    runtime: "142分钟",
    episodes: [],
    director: "陈屿",
    actors: ["林澈", "苏婉", "周慕云", "高野"],
    synopsis:
      "近未来，地球资源枯竭，一支由顶尖宇航员组成的远征队踏上寻找新家园的旅程。当飞船穿越虫洞后，队长程野发现星图上的坐标早已被神秘地改写。",
    status: "HD高清",
    views: 1283400,
    favorites: 86420,
    updatedAt: "2024-11-08",
    featured: true,
    tags: ["硬科幻", "视觉大片"],
  },
  {
    id: 2,
    title: "城市之光",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20crime%20drama%20movie%20poster%2C%20rain-soaked%20neon%20city%20street%20at%20night%20with%20a%20lone%20silhouette%20in%20a%20long%20coat%2C%20moody%20amber%20and%20steel%20grey%20tones%2C%20wet%20asphalt%20reflections%2C%20noir%20atmosphere%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m2&orientation=portrait",
    genres: ["剧情", "犯罪", "悬疑"],
    region: "中国大陆",
    year: 2024,
    rating: 8.8,
    runtime: "128分钟",
    episodes: [],
    director: "韩立",
    actors: ["张野", "刘诗雨", "王毅", "陈默"],
    synopsis:
      "一桩尘封十五年的悬案重启，退休刑警重返警队。在霓虹与雨水交织的城市里，真相藏在每一个被忽略的细节背后，也藏在他不愿面对的过去中。",
    status: "HD高清",
    views: 986220,
    favorites: 64100,
    updatedAt: "2024-10-22",
    featured: true,
    tags: ["犯罪悬疑", "口碑佳作"],
  },
  {
    id: 3,
    title: "山海秘境",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20oriental%20fantasy%20movie%20poster%2C%20misty%20ancient%20mountains%20with%20floating%20islands%20and%20a%20lone%20sword%20bearer%2C%20golden%20sunrise%20haze%2C%20lush%20green%20and%20warm%20gold%20palette%2C%20epic%20scale%20landscape%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m3&orientation=portrait",
    genres: ["奇幻", "动作", "古装"],
    region: "中国大陆",
    year: 2023,
    rating: 8.3,
    runtime: "136分钟",
    episodes: [],
    director: "顾长风",
    actors: ["云澈", "白露", "墨白", "江雪"],
    synopsis:
      "上古山海图卷散落人间，少年为寻回家族遗物踏入秘境。人、妖、灵三界暗流涌动，一场关乎苍生的抉择即将展开。",
    status: "HD高清",
    views: 872100,
    favorites: 58800,
    updatedAt: "2023-12-18",
    featured: true,
    tags: ["东方奇幻", "视觉盛宴"],
  },
  {
    id: 4,
    title: "追风者",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20action%20thriller%20movie%20poster%2C%20a%20lone%20driver%20on%20a%20winding%20coastal%20highway%20at%20dusk%2C%20speed%20blur%20motion%2C%20deep%20orange%20sunset%20and%20slate%20blue%20tones%2C%20gritty%20dramatic%20mood%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m4&orientation=portrait",
    genres: ["动作", "悬疑", "剧情"],
    region: "中国香港",
    year: 2024,
    rating: 8.1,
    runtime: "118分钟",
    episodes: [],
    director: "麦嘉良",
    actors: ["谢天华", "何洛", "林晓", "郑明"],
    synopsis:
      "地下车手被卷入一场跨国走私阴谋，唯一的出路是把真相送到终点。油门踩到底的每一秒，都是与死神擦肩。",
    status: "HD高清",
    views: 743900,
    favorites: 47200,
    updatedAt: "2024-09-15",
    featured: false,
    tags: ["竞速", "港式动作"],
  },
  {
    id: 5,
    title: "时差恋人",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20romance%20movie%20poster%2C%20two%20silhouettes%20standing%20far%20apart%20on%20a%20train%20platform%20at%20golden%20hour%2C%20soft%20warm%20blush%20and%20cream%20tones%2C%20bittersweet%20tender%20mood%2C%20dreamy%20bokeh%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m5&orientation=portrait",
    genres: ["爱情", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 7.9,
    runtime: "112分钟",
    episodes: [],
    director: "宋知遥",
    actors: ["许清", "陆遥", "安然"],
    synopsis:
      "作息完全错位的两个人，用一段段错过的语音留言谈了一场恋爱。当时间终于对上，他们还能认出彼此吗？",
    status: "HD高清",
    views: 612300,
    favorites: 41500,
    updatedAt: "2024-08-30",
    featured: false,
    tags: ["都市爱情", "治愈"],
  },
  {
    id: 6,
    title: "归途列车",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20family%20drama%20movie%20poster%2C%20an%20old%20green%20train%20crossing%20a%20vast%20rural%20landscape%20at%20dusk%2C%20a%20father%20and%20child%20seen%20from%20behind%2C%20muted%20olive%20and%20amber%20tones%2C%20nostalgic%20warm%20mood%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m6&orientation=portrait",
    genres: ["剧情", "家庭"],
    region: "中国大陆",
    year: 2023,
    rating: 8.6,
    runtime: "125分钟",
    episodes: [],
    director: "李怀安",
    actors: ["赵国强", "小满", "周慧", "刘波"],
    synopsis:
      "一位父亲带着失散多年的儿子踏上返乡的绿皮火车。三千公里的路途，他们重新学会如何开口说一句“回家”。",
    status: "HD高清",
    views: 528700,
    favorites: 39900,
    updatedAt: "2023-11-02",
    featured: false,
    tags: ["现实主义", "催泪"],
  },
  {
    id: 7,
    title: "暗夜守望",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20movie%20poster%2C%20a%20lone%20detective%20holding%20a%20flashlight%20in%20a%20dark%20abandoned%20warehouse%2C%20cold%20graphite%20and%20pale%20amber%20light%20shafts%2C%20tense%20suspenseful%20atmosphere%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m7&orientation=portrait",
    genres: ["犯罪", "悬疑", "剧情"],
    region: "韩国",
    year: 2024,
    rating: 8.9,
    runtime: "131分钟",
    episodes: [],
    director: "朴成勋",
    actors: ["金敏俊", "李智恩", "崔武"],
    synopsis:
      "连环失踪案的唯一线索，是一名每晚在废弃工厂值守的保安。他目睹了一切，却选择沉默——直到真相逼近自己。",
    status: "HD高清",
    views: 799500,
    favorites: 55300,
    updatedAt: "2024-07-19",
    featured: true,
    tags: ["韩式悬疑", "高能反转"],
  },
  {
    id: 8,
    title: "功夫小镇",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20comedy%20action%20movie%20poster%2C%20a%20young%20martial%20artist%20posing%20in%20a%20sunny%20traditional%20chinese%20town%20square%2C%20warm%20sunflower%20yellow%20and%20terracotta%20tones%2C%20playful%20energetic%20mood%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m8&orientation=portrait",
    genres: ["喜剧", "动作"],
    region: "中国大陆",
    year: 2024,
    rating: 7.6,
    runtime: "104分钟",
    episodes: [],
    director: "王大山",
    actors: ["大鹏", "柳岩", "陈翔"],
    synopsis:
      "外卖小哥误打误撞成了小镇武馆的“关门弟子”。为了保住武馆，他和一群怪咖邻居上演了一场爆笑逆袭。",
    status: "HD高清",
    views: 664200,
    favorites: 33800,
    updatedAt: "2024-06-08",
    featured: false,
    tags: ["合家欢", "轻松"],
  },
  {
    id: 9,
    title: "星际信使",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%2C%20a%20giant%20glowing%20ring%20space%20station%20orbiting%20a%20golden%20planet%2C%20small%20shuttle%20approaching%2C%20deep%20indigo%20space%20with%20amber%20highlights%2C%20awe%20inspiring%20scale%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m9&orientation=portrait",
    genres: ["科幻", "剧情"],
    region: "美国",
    year: 2023,
    rating: 8.4,
    runtime: "147分钟",
    episodes: [],
    director: "Alan Reed",
    actors: ["Ethan Cole", "Mia Grant", "Noah Blake"],
    synopsis:
      "人类收到来自深空的一段重复信号。语言学家被派往空间站解码，却发现这段信息来自三百年后的自己。",
    status: "HD高清",
    views: 921800,
    favorites: 61200,
    updatedAt: "2023-10-27",
    featured: true,
    tags: ["硬核科幻", "烧脑"],
  },
  {
    id: 10,
    title: "雨季不再来",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20coming%20of%20age%20movie%20poster%2C%20teenagers%20cycling%20through%20a%20rainy%20campus%20alley%20with%20umbrellas%2C%20soft%20mint%20green%20and%20pale%20gold%20tones%2C%20youthful%20nostalgic%20bittersweet%20mood%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m10&orientation=portrait",
    genres: ["青春", "爱情", "剧情"],
    region: "中国台湾",
    year: 2023,
    rating: 8.0,
    runtime: "108分钟",
    episodes: [],
    director: "林正宏",
    actors: ["陈嘉桦", "许光汉", "柯佳"],
    synopsis:
      "高三那年的梅雨季，两个人在同一把伞下约定：等雨停了，就去看海。多年后重聚，他们才明白有些约定是为了告别。",
    status: "HD高清",
    views: 458900,
    favorites: 37100,
    updatedAt: "2023-09-12",
    featured: false,
    tags: ["台湾青春", "文艺"],
  },
  {
    id: 11,
    title: "长风渡",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20chinese%20costume%20drama%20poster%2C%20an%20elegant%20young%20noblewoman%20in%20flowing%20silk%20robes%20standing%20before%20ancient%20palace%20terraces%2C%20warm%20gold%20and%20deep%20red%20tones%2C%20grand%20historical%20mood%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m11&orientation=portrait",
    genres: ["古装", "剧情", "爱情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.7,
    runtime: "45分钟/集",
    episodes: ["第1集 渡口初遇", "第2集 家族变故", "第3集 临危受命", "第4集 商路风云", "第5集 长夜将至", "第6集 破局之策"],
    director: "尹涛",
    actors: ["赵露", "刘宇", "张慧", "李铭"],
    synopsis:
      "名门嫡女与寒门书生结为契约夫妻，从针锋相对到携手并肩。乱世风云中，他们用智慧与深情守住了一方商路。",
    status: "全6集",
    views: 2145600,
    favorites: 132400,
    updatedAt: "2024-11-05",
    featured: true,
    tags: ["古装甜宠", "权谋"],
  },
  {
    id: 12,
    title: "都市浮生记",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20urban%20drama%20poster%2C%20a%20young%20professional%20looking%20out%20at%20a%20modern%20city%20skyline%20from%20a%20glass%20office%2C%20cool%20graphite%20and%20warm%20amber%20tones%2C%20contemplative%20mood%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m12&orientation=portrait",
    genres: ["都市", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.2,
    runtime: "42分钟/集",
    episodes: ["第1集 入职第一天", "第2集 房租账单", "第3集 职场暗流", "第4集 深夜加班", "第5集 转折时刻", "第6集 重新出发"],
    director: "张萌",
    actors: ["白宇", "杨蓉", "王凯", "宋佳"],
    synopsis:
      "四个合租的年轻人在一线城市打拼，每个人都在努力生活，也都在深夜崩溃。他们互相扶持，在浮世中寻找属于自己的位置。",
    status: "更新至第6集",
    views: 1678900,
    favorites: 98600,
    updatedAt: "2024-10-30",
    featured: false,
    tags: ["都市群像", "现实"],
  },
  {
    id: 13,
    title: "心动信号站",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20romance%20drama%20poster%2C%20a%20couple%20almost%20holding%20hands%20under%20warm%20string%20lights%20on%20a%20rooftop%2C%20soft%20peach%20and%20cream%20tones%2C%20sweet%20tender%20urban%20romance%20mood%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m13&orientation=portrait",
    genres: ["都市", "爱情", "喜剧"],
    region: "中国大陆",
    year: 2024,
    rating: 7.9,
    runtime: "38分钟/集",
    episodes: ["第1集 电梯偶遇", "第2集 乌龙误会", "第3集 心动瞬间", "第4集 告白预告", "第5集 双向奔赴"],
    director: "林妍",
    actors: ["周也", "陈飞宇", "张婧", "李昀"],
    synopsis:
      "高冷天体物理学家与新晋电台主播合租一间公寓。一个讲星星，一个讲心事，两条平行线慢慢有了交集。",
    status: "更新至第5集",
    views: 1432600,
    favorites: 88700,
    updatedAt: "2024-10-25",
    featured: true,
    tags: ["先婚后爱", "甜宠"],
  },
  {
    id: 14,
    title: "迷雾追凶",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20crime%20mystery%20tv%20poster%2C%20a%20detective%20examining%20a%20clue%20board%20covered%20in%20photos%20and%20red%20threads%20in%20a%20dim%20office%2C%20cold%20slate%20and%20amber%20tones%2C%20tense%20noir%20mood%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m14&orientation=portrait",
    genres: ["悬疑", "犯罪", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 9.0,
    runtime: "45分钟/集",
    episodes: ["第1集 失踪", "第2集 疑点", "第3集 暗线", "第4集 对峙", "第5集 真凶", "第6集 终局"],
    director: "陈正道",
    actors: ["秦昊", "王鸥", "李乃文", "张子枫"],
    synopsis:
      "小城连发三起相似失踪案，刑警队长抽丝剥茧，却发现所有线索都指向十五年前自己被封存的旧案。",
    status: "全6集",
    views: 2013400,
    favorites: 119800,
    updatedAt: "2024-11-01",
    featured: true,
    tags: ["本格推理", "零差评"],
  },
  {
    id: 15,
    title: "我的青春年代",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20youth%20campus%20drama%20poster%2C%20students%20running%20across%20a%20sunlit%20school%20playground%20with%20golden%20afternoon%20light%2C%20fresh%20sky%20blue%20and%20warm%20yellow%20tones%2C%20nostalgic%20energetic%20mood%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m15&orientation=portrait",
    genres: ["青春", "校园", "剧情"],
    region: "中国大陆",
    year: 2023,
    rating: 8.5,
    runtime: "40分钟/集",
    episodes: ["第1集 开学", "第2集 同桌", "第3集 运动会", "第4集 毕业季", "第5集 各奔东西"],
    director: "刘畅",
    actors: ["张新成", "李兰迪", "周依然"],
    synopsis:
      "一所普通高中的三年时光，记录了一群少年从懵懂到成长的青春。那些被珍藏的午后，成了他们一生的底色。",
    status: "全5集",
    views: 1187400,
    favorites: 79300,
    updatedAt: "2023-12-20",
    featured: false,
    tags: ["校园", "年代感"],
  },
  {
    id: 16,
    title: "大漠孤烟",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20historical%20war%20drama%20poster%2C%20an%20armored%20general%20standing%20on%20a%20desert%20dune%20before%20distant%20cavalry%20banners%2C%20warm%20sand%20gold%20and%20deep%20rust%20tones%2C%20epic%20solemn%20mood%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m16&orientation=portrait",
    genres: ["古装", "战争", "历史"],
    region: "中国大陆",
    year: 2024,
    rating: 8.8,
    runtime: "48分钟/集",
    episodes: ["第1集 边关急报", "第2集 孤城之围", "第3集 粮道危机", "第4集 背水一战", "第5集 功成身退"],
    director: "高希希",
    actors: ["胡军", "王阳", "张桐", "李沁"],
    synopsis:
      "边关孤城被围，守将仅剩三百残兵。他要在援军到来前，用一座空城和一场大雪，拖住敌军的十万铁骑。",
    status: "全5集",
    views: 1567800,
    favorites: 91200,
    updatedAt: "2024-09-28",
    featured: false,
    tags: ["历史正剧", "家国"],
  },
  {
    id: 17,
    title: "医者仁心",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20medical%20drama%20poster%2C%20a%20focused%20surgeon%20in%20scrubs%20standing%20in%20a%20bright%20hospital%20corridor%2C%20clean%20white%20teal%20and%20warm%20amber%20accents%2C%20hopeful%20serious%20mood%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m17&orientation=portrait",
    genres: ["都市", "职场", "剧情"],
    region: "中国大陆",
    year: 2023,
    rating: 8.3,
    runtime: "42分钟/集",
    episodes: ["第1集 急诊夜", "第2集 生死抉择", "第3集 医患之间", "第4集 传承"],
    director: "曹盾",
    actors: ["靳东", "海清", "张嘉译"],
    synopsis:
      "三甲医院急诊科主任与年轻实习医生之间，是理念的碰撞，也是医者信念的传承。每一台手术背后，都是一个家庭的希望。",
    status: "全4集",
    views: 1023400,
    favorites: 67800,
    updatedAt: "2023-11-15",
    featured: false,
    tags: ["医疗", "群像"],
  },
  {
    id: 18,
    title: "隐秘真相",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20suspense%20drama%20poster%2C%20a%20woman%20reflected%20in%20a%20foggy%20window%20at%20night%2C%20her%20expression%20unreadable%2C%20cold%20steel%20grey%20and%20faint%20amber%20light%2C%20quiet%20eerie%20mood%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m18&orientation=portrait",
    genres: ["悬疑", "剧情", "家庭"],
    region: "中国大陆",
    year: 2024,
    rating: 8.6,
    runtime: "44分钟/集",
    episodes: ["第1集 归来", "第2集 疑云", "第3集 旧照片", "第4集 真相", "第5集 放下"],
    director: "辛爽",
    actors: ["张译", "刘琳", "范伟"],
    synopsis:
      "消失二十年的母亲突然出现在老宅门口。女儿想弄清她当年为何离开，却发现真相远比想象中沉重。",
    status: "全5集",
    views: 1398200,
    favorites: 84600,
    updatedAt: "2024-10-18",
    featured: false,
    tags: ["家庭悬疑", "演技派"],
  },
  {
    id: 19,
    title: "快乐出发吧",
    type: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20variety%20show%20poster%2C%20a%20group%20of%20cheerful%20friends%20jumping%20on%20a%20sunny%20beach%20holding%20travel%20gear%2C%20vivid%20sunflower%20yellow%20and%20sky%20blue%20tones%2C%20joyful%20energetic%20mood%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m19&orientation=portrait",
    genres: ["真人秀", "旅行", "喜剧"],
    region: "中国大陆",
    year: 2024,
    rating: 7.7,
    runtime: "90分钟/期",
    episodes: ["第1期 出发", "第2期 荒野营地", "第3期 海岛任务", "第4期 城市挑战", "第5期 收官夜"],
    director: "综艺制作组",
    actors: ["何炅", "谢娜", "大张伟", "王勉"],
    synopsis:
      "六位固定嘉宾开启一场没有脚本的旅行，用最真实的方式打卡祖国的山川湖海，也记录每一个笑到停不下来的瞬间。",
    status: "更新至第5期",
    views: 1876500,
    favorites: 102300,
    updatedAt: "2024-11-03",
    featured: true,
    tags: ["旅行真人秀", "减压"],
  },
  {
    id: 20,
    title: "音乐浪潮",
    type: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20music%20competition%20show%20poster%2C%20a%20singer%20performing%20on%20a%20glowing%20concert%20stage%20with%20spotlights%2C%20deep%20stage%20purple%20and%20warm%20gold%20highlights%2C%20electric%20passionate%20mood%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m20&orientation=portrait",
    genres: ["音乐", "竞技", "真人秀"],
    region: "中国大陆",
    year: 2024,
    rating: 8.1,
    runtime: "100分钟/期",
    episodes: ["第1期 初舞台", "第2期 双人对决", "第3期 乐队改编", "第4期 原创之夜", "第5期 总决赛"],
    director: "音乐综艺组",
    actors: ["那英", "周深", "单依纯", "毛不易"],
    synopsis:
      "来自不同领域的音乐人同台竞技，用原创和改编重新定义舞台。每一首表演都是一次对音乐的真诚告白。",
    status: "已完结",
    views: 2143900,
    favorites: 128600,
    updatedAt: "2024-08-12",
    featured: true,
    tags: ["音乐竞技", "神仙打架"],
  },
  {
    id: 21,
    title: "美食奇遇记",
    type: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20food%20travel%20show%20poster%2C%20a%20steaming%20bowl%20of%20noodles%20on%20a%20rustic%20wooden%20table%20with%20chopsticks%2C%20warm%20amber%20and%20terracotta%20tones%2C%20appetizing%20cozy%20mood%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m21&orientation=portrait",
    genres: ["美食", "真人秀", "旅行"],
    region: "中国大陆",
    year: 2023,
    rating: 8.0,
    runtime: "60分钟/期",
    episodes: ["第1期 街头小吃", "第2期 山里人家", "第3期 夜宵江湖", "第4期 家宴"],
    director: "美食纪录片组",
    actors: ["陈晓卿", "美食嘉宾团"],
    synopsis:
      "走遍大江南北，只为找到那一口让人念念不忘的味道。每一家小馆背后，都藏着一个关于坚持与烟火气的故事。",
    status: "全4期",
    views: 1328700,
    favorites: 82500,
    updatedAt: "2023-12-05",
    featured: false,
    tags: ["美食探店", "治愈"],
  },
  {
    id: 22,
    title: "明星大侦探社",
    type: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20mystery%20game%20show%20poster%2C%20a%20group%20of%20people%20in%20vintage%20detective%20outfits%20standing%20around%20a%20dim%20study%20with%20clues%2C%20moody%20emerald%20and%20amber%20tones%2C%20playful%20suspenseful%20mood%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m22&orientation=portrait",
    genres: ["推理", "真人秀", "喜剧"],
    region: "中国大陆",
    year: 2024,
    rating: 8.4,
    runtime: "95分钟/期",
    episodes: ["第1期 迷雾庄园", "第2期 海上密室", "第3期 古宅疑云", "第4期 终极对局"],
    director: "推理综艺组",
    actors: ["何炅", "撒贝宁", "白敬亭", "王鸥"],
    synopsis:
      "每期一个独立案件，嘉宾在实景剧本中寻找线索、推理真相。烧脑与爆笑齐飞，谁能成为最后的侦探？",
    status: "更新至第4期",
    views: 1693200,
    favorites: 97600,
    updatedAt: "2024-10-12",
    featured: false,
    tags: ["推理", "实景"],
  },
  {
    id: 23,
    title: "舞台之光",
    type: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20dance%20competition%20show%20poster%2C%20dancers%20mid-motion%20on%20a%20spotlit%20stage%20with%20dramatic%20shadows%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20powerful%20elegant%20mood%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m23&orientation=portrait",
    genres: ["舞蹈", "竞技", "音乐"],
    region: "中国大陆",
    year: 2024,
    rating: 8.2,
    runtime: "85分钟/期",
    episodes: ["第1期 海选", "第2期 双人舞", "第3期 主题之夜", "第4期 半决赛", "第5期 巅峰对决"],
    director: "舞蹈综艺组",
    actors: ["杨丽萍", "金星", "刘宪华", "朱正廷"],
    synopsis:
      "来自不同舞种的选手同台切磋，从民族舞到街舞，用身体讲述故事。灯光亮起的那一刻，舞台属于每一个热爱的人。",
    status: "已完结",
    views: 1423600,
    favorites: 88300,
    updatedAt: "2024-07-25",
    featured: false,
    tags: ["舞蹈竞技", "燃"],
  },
  {
    id: 24,
    title: "环球旅行家",
    type: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20travel%20show%20poster%2C%20a%20traveler%20standing%20on%20a%20cliff%20overlooking%20a%20vast%20golden%20sunset%20landscape%20with%20a%20map%2C%20warm%20amber%20and%20muted%20teal%20tones%2C%20adventurous%20wanderlust%20mood%2C%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=xg-m24&orientation=portrait",
    genres: ["旅行", "纪录", "真人秀"],
    region: "英国",
    year: 2023,
    rating: 8.5,
    runtime: "50分钟/期",
    episodes: ["第1期 极地之旅", "第2期 沙漠星空", "第3期 雨林深处", "第4期 海岛余生"],
    director: "BBC Travel Unit",
    actors: ["James Holt", "Sofia Reyes"],
    synopsis:
      "两位旅行者用一年的时间走遍七大洲最偏远的角落。镜头记录下壮丽的自然，也记录下人与人之间最朴素的相遇。",
    status: "全4期",
    views: 967800,
    favorites: 63200,
    updatedAt: "2023-10-08",
    featured: false,
    tags: ["旅行纪录", "风光"],
  },
];